import * as z from "zod";

export const campaignLogin = {
  name: "campaignLogin" as const,
  input: z.object({
    email: z.email(),
    campaignSlug: z.string().min(1, "Campaign slug is required"),
  }),
  output: z.object({
    success: z.boolean(),
    campaignName: z.string(),
    endsAt: z.string(), // ISO string
    message: z.string().optional(),
  }),
};
